
let waiting_modal = content => {
    let modal = crel('div', {id: 'waitingModal', class: 'modal bottom-sheet'},
        crel('div', {class: 'modal-content'},
            crel('div', {class: 'progress'}, crel('div', {class: 'indeterminate', style: 'background-color: #808080'})),
            crel('h4', 'Samo trenutek!'),
            crel('p', content)
        ),
    )
    let m = M.Modal.init(modal, {dismissible: false})
    crel(document.body, crel('div', {class: 'materializecss'}, modal))
    m.open()
}


export {
    waiting_modal
}